import makeExports from './exports';
import type {StyleDeclarationValue, StyleDeclaration, CSSProperties, CSSPropertiesComplete} from './exports';

const useImportant = false; // Add !important to all style definitions

const Aphrodite = makeExports(useImportant);

const {
    StyleSheet,
    renderStatic,
    css,
    minify,
    flushToStyleTag,
    injectAndGetClassName,
    defaultSelectorHandlers,
    reset,
    resetInjectedStyle,
} = Aphrodite;

export {
    StyleSheet,
    renderStatic,
    css,
    minify,
    flushToStyleTag,
    injectAndGetClassName,
    defaultSelectorHandlers,
    reset,
    resetInjectedStyle,
    CSSProperties,
    CSSPropertiesComplete,
    StyleDeclaration,
    StyleDeclarationValue,
};
